<template>
    <a-modal  title="查看视频" :visible="visible" cancelText="取消" okText="确定" @ok="handleOk" @cancel="handleCancel" width="70%">
             <a-carousel autoplay arrows>
                <div
                slot="prevArrow"
                slot-scope="props"
                class="custom-slick-arrow"
                style="left: 10px;zIndex: 1"
                >
                <a-icon type="left-circle" />
                </div>
                <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
                <a-icon type="right-circle" />
                </div>
               <div v-for="(item,index) in list" :key="index">
                    <video :src="item" controls="controls" height="360px">您的浏览器不支持 video 标签。</video>
                </div>   
            </a-carousel>
    </a-modal>
</template>
<script>
export default {
   data(){
       return{
          visible:false,
          list:[]
       }
   },
   methods:{
       showDialog(list){
            this.list = list;
            this.visible = true;
       },
        handleOk(e) {
            this.visible = false;
        },
        handleCancel(e) {
            this.visible = false;
        },
   }
}
</script>
<style>
    .ant-carousel  .slick-slide {
    text-align: center;
    height: 360px;
    line-height: 360px;
    background: #364d79;
    overflow: hidden;
  }
  
  .ant-carousel  .custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
  }
  .ant-carousel  .custom-slick-arrow:before {
    display: none;
  }
  .ant-carousel  .custom-slick-arrow:hover {
    opacity: 0.5;
  }
  
  .ant-carousel  .slick-slide h3 {
    color: #fff;
  }
</style>